var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-page",
    { staticClass: "relative invoice-create-page" },
    [
      !_vm.isLoadingInvoice && !_vm.isLoadingData
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm($event)
                }
              }
            },
            [
              _c(
                "sw-page-header",
                { attrs: { title: _vm.pageTitle } },
                [
                  _c(
                    "sw-breadcrumb",
                    { attrs: { slot: "breadcrumbs" }, slot: "breadcrumbs" },
                    [
                      _c("sw-breadcrumb-item", {
                        attrs: {
                          to: "/admin/dashboard",
                          title: _vm.$t("general.home")
                        }
                      }),
                      _vm._v(" "),
                      _c("sw-breadcrumb-item", {
                        attrs: {
                          to: "/admin/invoices",
                          title: _vm.$tc("invoices.invoice", 2)
                        }
                      }),
                      _vm._v(" "),
                      _vm.$route.name === "invoice.edit"
                        ? _c("sw-breadcrumb-item", {
                            attrs: {
                              to: "#",
                              title: _vm.$t("invoices.edit_invoice"),
                              active: ""
                            }
                          })
                        : _c("sw-breadcrumb-item", {
                            attrs: {
                              to: "#",
                              title: _vm.$t("invoices.new_invoice"),
                              active: ""
                            }
                          })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "actions" },
                    [
                      _vm.$route.name === "invoices.edit"
                        ? _c(
                            "sw-button",
                            {
                              staticClass: "mr-3",
                              attrs: {
                                disabled: _vm.isLoading,
                                "tag-name": "a",
                                href:
                                  "/invoices/pdf/" + _vm.newInvoice.unique_hash,
                                variant: "primary-outline",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("general.view_pdf")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "sw-button",
                        {
                          staticClass: "flex justify-center w-full lg:w-auto",
                          attrs: {
                            loading: _vm.isLoading,
                            disabled: _vm.isLoading,
                            variant: "primary",
                            type: "submit",
                            size: "lg"
                          }
                        },
                        [
                          !_vm.isLoading
                            ? _c("save-icon", { staticClass: "mr-2 -ml-1" })
                            : _vm._e(),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("invoices.save_invoice")) +
                              "\n        "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid-cols-12 gap-8 mt-6 mb-8 lg:grid" },
                [
                  _c("customer-select", {
                    staticClass: "col-span-5 pr-0",
                    attrs: {
                      valid: _vm.$v.selectedCustomer,
                      "customer-id": _vm.customerId
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-1 col-span-7 gap-4 mt-8 lg:gap-6 lg:mt-0 lg:grid-cols-2"
                    },
                    [
                      _c(
                        "sw-input-group",
                        {
                          attrs: {
                            label: _vm.$t("invoices.invoice_date"),
                            error: _vm.invoiceDateError,
                            required: ""
                          }
                        },
                        [
                          _c("base-date-picker", {
                            staticClass: "mt-2",
                            attrs: {
                              "calendar-button": true,
                              "calendar-button-icon": "calendar"
                            },
                            on: {
                              change: function($event) {
                                return _vm.$v.newInvoice.invoice_date.$touch()
                              }
                            },
                            model: {
                              value: _vm.newInvoice.invoice_date,
                              callback: function($$v) {
                                _vm.$set(_vm.newInvoice, "invoice_date", $$v)
                              },
                              expression: "newInvoice.invoice_date"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "sw-input-group",
                        {
                          attrs: {
                            label: _vm.$t("invoices.due_date"),
                            error: _vm.dueDateError,
                            required: ""
                          }
                        },
                        [
                          _c("base-date-picker", {
                            staticClass: "mt-2",
                            attrs: {
                              invalid: _vm.$v.newInvoice.due_date.$error,
                              "calendar-button": true,
                              "calendar-button-icon": "calendar"
                            },
                            on: {
                              change: function($event) {
                                return _vm.$v.newInvoice.due_date.$touch()
                              }
                            },
                            model: {
                              value: _vm.newInvoice.due_date,
                              callback: function($$v) {
                                _vm.$set(_vm.newInvoice, "due_date", $$v)
                              },
                              expression: "newInvoice.due_date"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "sw-input-group",
                        {
                          staticClass: "lg:mt-0",
                          attrs: {
                            label: _vm.$t("invoices.invoice_number"),
                            error: _vm.invoiceNumError,
                            required: ""
                          }
                        },
                        [
                          _c(
                            "sw-input",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                prefix: _vm.invoicePrefix + " - ",
                                invalid: _vm.$v.invoiceNumAttribute.$error
                              },
                              on: {
                                input: function($event) {
                                  return _vm.$v.invoiceNumAttribute.$touch()
                                }
                              },
                              model: {
                                value: _vm.invoiceNumAttribute,
                                callback: function($$v) {
                                  _vm.invoiceNumAttribute = $$v
                                },
                                expression: "invoiceNumAttribute"
                              }
                            },
                            [
                              _c("hashtag-icon", {
                                staticClass: "h-4 ml-1 text-gray-500",
                                attrs: { slot: "leftIcon" },
                                slot: "leftIcon"
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "sw-input-group",
                        {
                          staticClass: "lg:mt-0",
                          attrs: {
                            label: _vm.$t("invoices.ref_number"),
                            error: _vm.referenceError
                          }
                        },
                        [
                          _c(
                            "sw-input",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                invalid:
                                  _vm.$v.newInvoice.reference_number.$error
                              },
                              on: {
                                input: function($event) {
                                  return _vm.$v.newInvoice.reference_number.$touch()
                                }
                              },
                              model: {
                                value: _vm.newInvoice.reference_number,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.newInvoice,
                                    "reference_number",
                                    $$v
                                  )
                                },
                                expression: "newInvoice.reference_number"
                              }
                            },
                            [
                              _c("hashtag-icon", {
                                staticClass: "h-4 ml-1 text-gray-500",
                                attrs: { slot: "leftIcon" },
                                slot: "leftIcon"
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "w-full text-center item-table" },
                [
                  _c("colgroup", [
                    _c("col", { staticStyle: { width: "40%" } }),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "10%" } }),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "15%" } }),
                    _vm._v(" "),
                    _vm.discountPerItem === "YES"
                      ? _c("col", { staticStyle: { width: "15%" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("col", { staticStyle: { width: "15%" } })
                  ]),
                  _vm._v(" "),
                  _c(
                    "thead",
                    {
                      staticClass:
                        "bg-white border border-gray-200 border-solid"
                    },
                    [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass:
                              "px-5 py-3 text-sm not-italic font-medium leading-5 text-left text-gray-700 border-t border-b border-gray-200 border-solid"
                          },
                          [
                            _c("span", { staticClass: "pl-12" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$tc("items.item", 2)) +
                                  "\n            "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass:
                              "px-5 py-3 text-sm not-italic font-medium leading-5 text-right text-gray-700 border-t border-b border-gray-200 border-solid"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("invoices.item.quantity")) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass:
                              "px-5 py-3 text-sm not-italic font-medium leading-5 text-left text-gray-700 border-t border-b border-gray-200 border-solid"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("invoices.item.price")) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.discountPerItem === "YES"
                          ? _c(
                              "th",
                              {
                                staticClass:
                                  "px-5 py-3 text-sm not-italic font-medium leading-5 text-left text-gray-700 border-t border-b border-gray-200 border-solid"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("invoices.item.discount")) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass:
                              "px-5 py-3 text-sm not-italic font-medium leading-5 text-right text-gray-700 border-t border-b border-gray-200 border-solid"
                          },
                          [
                            _c("span", { staticClass: "pr-10" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("invoices.item.amount")) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "item-body",
                      attrs: { tag: "tbody", handle: ".handle" },
                      model: {
                        value: _vm.newInvoice.items,
                        callback: function($$v) {
                          _vm.$set(_vm.newInvoice, "items", $$v)
                        },
                        expression: "newInvoice.items"
                      }
                    },
                    _vm._l(_vm.newInvoice.items, function(item, index) {
                      return _c("invoice-item", {
                        key: item.id,
                        attrs: {
                          index: index,
                          "item-data": item,
                          "invoice-items": _vm.newInvoice.items,
                          currency: _vm.currency,
                          "tax-per-item": _vm.taxPerItem,
                          "discount-per-item": _vm.discountPerItem
                        },
                        on: {
                          remove: _vm.removeItem,
                          update: _vm.updateItem,
                          itemValidate: _vm.checkItemsData
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-center w-full px-6 py-3 text-base border-b border-gray-200 border-solid cursor-pointer text-primary-400 hover:bg-gray-200",
                  on: { click: _vm.addItem }
                },
                [
                  _c("shopping-cart-icon", { staticClass: "h-5 mr-2" }),
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("invoices.add_item")) + "\n    "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "block my-10 invoice-foot lg:justify-between lg:flex lg:items-start"
                },
                [
                  _c(
                    "div",
                    { staticClass: "w-full lg:w-1/2" },
                    [
                      _c(
                        "div",
                        { staticClass: "mb-6" },
                        [
                          _c(
                            "sw-popup",
                            {
                              ref: "notePopup",
                              staticClass:
                                "text-sm font-semibold leading-5 text-primary-400"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "float-right mt-1",
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _vm._v(
                                    "\n              + " +
                                      _vm._s(_vm.$t("general.insert_note")) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("note-select-popup", {
                                attrs: { type: "Invoice" },
                                on: { select: _vm.onSelectNote }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "sw-input-group",
                            { attrs: { label: _vm.$t("invoices.notes") } },
                            [
                              _c("base-custom-input", {
                                attrs: { fields: _vm.InvoiceFields },
                                model: {
                                  value: _vm.newInvoice.notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newInvoice, "notes", $$v)
                                  },
                                  expression: "newInvoice.notes"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.customFields.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "grid gap-x-4 gap-y-2 md:gap-x-8 md:gap-y-4 grid-col-1 md:grid-cols-2"
                            },
                            _vm._l(_vm.customFields, function(field, index) {
                              return _c(
                                "sw-input-group",
                                {
                                  key: index,
                                  attrs: {
                                    label: field.label,
                                    required: field.is_required ? true : false
                                  }
                                },
                                [
                                  _c(field.type + "Field", {
                                    tag: "component",
                                    attrs: {
                                      type: field.type.label,
                                      field: field,
                                      isEdit: _vm.isEdit,
                                      "invalid-fields": _vm.invalidFields
                                    },
                                    on: { update: _vm.setCustomFieldValue }
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "sw-input-group",
                        {
                          staticClass: "mt-6 mb-1",
                          attrs: {
                            label: _vm.$t("invoices.invoice_template"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "sw-button",
                            {
                              staticClass:
                                "flex justify-center w-full text-sm lg:w-auto",
                              attrs: { type: "button", variant: "gray" },
                              on: { click: _vm.openTemplateModal }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "flex text-black" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("invoices.template")) +
                                      " " +
                                      _vm._s(_vm.getTemplateId) +
                                      "\n              "
                                  ),
                                  _c("pencil-icon", {
                                    staticClass: "h-5 ml-2 -mr-1"
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-5 py-4 mt-6 bg-white border border-gray-200 border-solid rounded invoice-total lg:mt-0"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between w-full"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "text-sm font-semibold leading-5 text-gray-500 uppercase"
                            },
                            [_vm._v(_vm._s(_vm.$t("invoices.sub_total")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "flex items-center justify-center m-0 text-lg text-black uppercase"
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$utils.formatMoney(
                                      _vm.subtotal,
                                      _vm.currency
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.allTaxes, function(tax) {
                        return _c(
                          "div",
                          {
                            key: tax.tax_type_id,
                            staticClass:
                              "flex items-center justify-between w-full"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "m-0 text-sm font-semibold leading-5 text-gray-500 uppercase"
                              },
                              [
                                _vm._v(
                                  _vm._s(tax.name) +
                                    " - " +
                                    _vm._s(tax.percent) +
                                    "%\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "flex items-center justify-center m-0 text-lg text-black uppercase",
                                staticStyle: { "font-size": "18px" }
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$utils.formatMoney(
                                        tax.amount,
                                        _vm.currency
                                      )
                                    )
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.discountPerItem === "NO" ||
                      _vm.discountPerItem === null
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-between w-full mt-2"
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-semibold leading-5 text-gray-500 uppercase"
                                },
                                [_vm._v(_vm._s(_vm.$t("invoices.discount")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "flex",
                                  staticStyle: { width: "105px" },
                                  attrs: { role: "group" }
                                },
                                [
                                  _c("sw-input", {
                                    staticClass:
                                      "border-r-0 rounded-tr-sm rounded-br-sm",
                                    attrs: {
                                      invalid:
                                        _vm.$v.newInvoice.discount_val.$error
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.$v.newInvoice.discount_val.$touch()
                                      }
                                    },
                                    model: {
                                      value: _vm.discount,
                                      callback: function($$v) {
                                        _vm.discount = $$v
                                      },
                                      expression: "discount"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "sw-dropdown",
                                    { attrs: { position: "bottom-end" } },
                                    [
                                      _c(
                                        "sw-button",
                                        {
                                          staticClass:
                                            "flex items-center justify-center w-12 border border-gray-300 border-solid rounded-tl-none rounded-bl-none font-base",
                                          staticStyle: { height: "43px" },
                                          attrs: {
                                            slot: "activator",
                                            type: "button",
                                            "data-toggle": "dropdown",
                                            "aria-haspopup": "true",
                                            "aria-expanded": "false",
                                            variant: "white"
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "flex" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.newInvoice
                                                      .discount_type == "fixed"
                                                      ? _vm.currency.symbol
                                                      : "%"
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("chevron-down-icon", {
                                                staticClass: "h-5"
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "sw-dropdown-item",
                                        { on: { click: _vm.selectFixed } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("general.fixed")) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "sw-dropdown-item",
                                        { on: { click: _vm.selectPercentage } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("general.percentage")
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.taxPerItem
                      ? "NO"
                      : null)
                        ? _c(
                            "div",
                            _vm._l(_vm.newInvoice.taxes, function(tax, index) {
                              return _c("tax", {
                                key: tax.id,
                                attrs: {
                                  index: index,
                                  total: _vm.subtotalWithDiscount,
                                  tax: tax,
                                  taxes: _vm.newInvoice.taxes,
                                  currency: _vm.currency,
                                  "total-tax": _vm.totalSimpleTax
                                },
                                on: {
                                  remove: _vm.removeInvoiceTax,
                                  update: _vm.updateTax
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.taxPerItem === "NO" || _vm.taxPerItem === null
                        ? _c(
                            "sw-popup",
                            {
                              ref: "taxModal",
                              staticClass:
                                "my-3 text-sm font-semibold leading-5 text-primary-400"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "float-right pt-2 pb-5",
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _vm._v(
                                    "\n            + " +
                                      _vm._s(_vm.$t("invoices.add_tax")) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("tax-select-popup", {
                                attrs: { taxes: _vm.newInvoice.taxes },
                                on: { select: _vm.onSelectTax }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between w-full pt-2 mt-5 border-t border-gray-200 border-solid"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "text-sm font-semibold leading-5 text-gray-500 uppercase"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("invoices.total")) +
                                  " " +
                                  _vm._s(_vm.$t("invoices.amount")) +
                                  ":\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "flex items-center justify-center text-lg uppercase text-primary-400"
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$utils.formatMoney(
                                      _vm.total,
                                      _vm.currency
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        : _c("base-loader")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }